import { createSelector, createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';
import { EXTENDED_LOADING_FILTER, SUPPLIER_AUTH_FILTERS } from '../../../../utils/constants';
import { ANY_OPTION } from '../../utils/const';

const initialState = {
  active: SUPPLIER_AUTH_FILTERS.any,
  authType: '',
  authorizationSelection: SUPPLIER_AUTH_FILTERS.all,
  carrierName: SUPPLIER_AUTH_FILTERS.any,
  exchange: SUPPLIER_AUTH_FILTERS.any,
  extendedLoadingSelection: EXTENDED_LOADING_FILTER.all,
  inventoryOwner: SUPPLIER_AUTH_FILTERS.any,
  limitType: SUPPLIER_AUTH_FILTERS.any,
  loadingAllowed: SUPPLIER_AUTH_FILTERS.any,
  location: SUPPLIER_AUTH_FILTERS.any,
  nameShort: SUPPLIER_AUTH_FILTERS.any,
  product: SUPPLIER_AUTH_FILTERS.any,
  relatedIds: [],
  searchTerm: '',
  selectedIndex: undefined,
  state: SUPPLIER_AUTH_FILTERS.any,
  status: SUPPLIER_AUTH_FILTERS.any,
  supplier: SUPPLIER_AUTH_FILTERS.any,
  tempCardFilter: {},
  tempSearchTerm: '',
  type: SUPPLIER_AUTH_FILTERS.any,
};

const reducers = {
  resetCardFilters(state) {
    return {
      ...state,
      active: SUPPLIER_AUTH_FILTERS.any,
      authorizationSelection: SUPPLIER_AUTH_FILTERS.all,
      carrierName: SUPPLIER_AUTH_FILTERS.any,
      exchange: SUPPLIER_AUTH_FILTERS.any,
      extendedLoadingSelection: SUPPLIER_AUTH_FILTERS.all,
      inventoryOwner: SUPPLIER_AUTH_FILTERS.any,
      limitType: SUPPLIER_AUTH_FILTERS.any,
      loadingAllowed: SUPPLIER_AUTH_FILTERS.any,
      location: SUPPLIER_AUTH_FILTERS.any,
      nameShort: SUPPLIER_AUTH_FILTERS.any,
      product: SUPPLIER_AUTH_FILTERS.any,
      relatedIds: state.relatedIds,
      state: SUPPLIER_AUTH_FILTERS.any,
      status: SUPPLIER_AUTH_FILTERS.any,
      supplier: SUPPLIER_AUTH_FILTERS.any,
      type: SUPPLIER_AUTH_FILTERS.any,
    };
  },
  resetFilters(state) {
    const initState = {
      ...initialState,
      authType: state.authType,
      tempCardFilter: state.tempCardFilter,
      tempSearchTerm: state.tempSearchTerm,
    };
    return initState;
  },
  resetSingleFilter(state, { payload: { name } }) {
    return { ...state, [name]: initialState[name] };
  },
  resetTempFilters(state) {
    return {
      ...state,
      tempCardFilter: initialState.tempCardFilter,
      tempSearchTerm: initialState.tempSearchTerm,
    };
  },
  setFilters(state, { payload: { name, value } }) {
    return R.assoc(name, value, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'filters',
  reducers,
});

export const { resetCardFilters, resetFilters, resetSingleFilter, resetTempFilters, setFilters } =
  actions;

// Selectors
export const getApplicableFilters = R.o(
  R.pick([
    'active',
    'authorizationSelection',
    'carrierName',
    'exchange',
    'extendedLoadingSelection',
    'inventoryOwner',
    'limitType',
    'loadingAllowed',
    'location',
    'nameShort',
    'product',
    'state',
    'status',
    'supplier',
    'type',
  ]),
  R.path(['loadingManagement', 'filters'])
);

// get filter option arrays
export const getFilterOptions = (state, path, cardsFunc) =>
  R.compose(
    R.prepend(ANY_OPTION),
    R.map(item => ({ label: item, value: item })),
    R.sortBy(R.identity),
    R.uniqBy(R.identity),
    R.map(R.path(path)),
    cardsFunc
  )(state);

export const getFilterIdentifierCount = createSelector(
  getApplicableFilters,
  R.compose(R.length, R.reject(R.either(R.equals('Any'), R.equals('All'))), R.values)
);

// Actions
export const clearFilter = filterSelections => dispatch => {
  Object.keys(filterSelections).forEach(key => {
    if (filterSelections[key] !== SUPPLIER_AUTH_FILTERS.any) {
      dispatch(setFilters({ name: key, value: SUPPLIER_AUTH_FILTERS.any }));
    }
  });
};

export default reducer;
